import { Role } from './role.model';

export class User {
  id?: number;
  firstName = '';
  lastName = '';
  email?: string;
  username?: string;
  role = new Role({});
  department?: string;
  changeablePassword?: boolean;
  imageUrl?: string;
  group?: string[] = [];
  countryCode?: number;
  phone?: number;
  country?: string;
  activated?: string | number;
  lastAppLoginStatus?: number;
  lastAppLogin?: string;
  lastAppActivityStatus?: number;
  lastAppActivity?: string;
  registered?: boolean;
  backupFile?: string;
  status?: number;
  lang?: string;
  showRelaseNote = false;
  a2fStatus = false;
  containError?: string[];
  contingencyBackupKey: string = ''
  desktopVersion?: string = '';
  mobileVersion?: string = '';
  showUserJourney?: boolean = false;

  constructor(input: any) {
    if (input.id) {
      this.id = input.id;
    }
    this.firstName = input.firstName;
    this.lastName = input.lastName;
    this.role = new Role(input.role ? input.role : {});
    if (input.email) {
      this.email = input.email;
    }
    if (input.username) {
      this.username = input.username;
    }
    if (input.changeablePassword) {
      this.changeablePassword = input.changeablePassword;
    }
    if (input.imageUrl) {
      this.imageUrl = input.imageUrl;
    }
    this.group = input.group ? input.group : [];
    if (input.countryCode) {
      this.countryCode = input.countryCode;
    }
    if (input.phone) {
      this.phone = input.phone;
    }
    if (input.country) {
      this.country = input.country;
    }
    if (input.activated) {
      this.activated = input.activated;
    }
    if (input.lastAppActivity) {
      this.lastAppActivity = input.lastAppActivity;
    }
    if (input.registered) {
      this.registered = input.registered;
    }
    if (input.backupFile) {
      this.backupFile = input.backupFile;
    }
    if (input.status) {
      this.status = input.status;
    }
    if (input.lang) {
      this.lang = input.lang;
    }
    if (input.showRelaseNote) {
      this.showRelaseNote = input.showRelaseNote;
    }
    if (input.a2fStatus) {
      this.a2fStatus = input.a2fStatus;
    }
    if (input.department) {
      this.department = input.department;
    }
    if (input.containError) {
      this.containError = input.containError;
    }
    if (input.mobileVersion) {
      this.mobileVersion = input.mobileVersion;
    }
    if (input.desktopVersion) {
      this.desktopVersion = input.desktopVersion;
    }
    if (input.showUserJourney) {
      this.showUserJourney = input.showUserJourney;
    }
    this.contingencyBackupKey = input.contingencyBackupKey;

  }

  getFilter(extraFilter?) {
    const filter: any = {};
    if (extraFilter && extraFilter.replace(/\s/g, '').length > 0) {
      filter.search = extraFilter;
    }
    if (this.firstName && this.firstName.replace(/\s/g, '').length > 0) {
      filter.firstName = this.firstName;
    }
    if (this.lastName && this.lastName.replace(/\s/g, '').length > 0) {
      filter.lastName = this.lastName;
    }
    if (this.email && this.email.replace(/\s/g, '').length > 0) {
      filter.email = this.email;
    }
    if (this.username && this.username.replace(/\s/g, '').length > 0) {
      filter.username = this.username;
    }
    if (this.country && this.country.replace(/\s/g, '').length > 0) {
      filter.country = this.country;
    }
    if (this.department && this.department.replace(/\s/g, '').length > 0) {
      filter.department = this.department;
    }
    if (this.phone) {
      filter.phone = this.phone;
    }
    if (this.activated) {
      filter.activated = +this.activated - 1;
    }
    if (this.lastAppLoginStatus) {
      filter.lastAppLoginStatus = +this.lastAppLoginStatus;
    }
    if (this.lastAppActivityStatus) {
      filter.lastAppActivityStatus = +this.lastAppActivityStatus;
    }
    if (typeof this.registered === 'boolean') {
      filter.registered = this.registered ? 1 : 0;
    }
    if (this.group.length > 0) {
      filter.group = this.group[0];
    }
    if (this.role.name && this.role.name.replace(/\s/g, '').length > 0) {
      filter.role = this.role.name;
    }
    if (this.mobileVersion && this.mobileVersion.replace(/\s/g, '').length > 0) {
      filter.mobileVersion = this.mobileVersion;
    }
    if (this.desktopVersion && this.desktopVersion.replace(/\s/g, '').length > 0) {
      filter.desktopVersion = this.desktopVersion;
    }
    return filter;
  }

  prepareFilterSearch(pagination, extraFilter?) {
    const filter: any = this.getFilter(extraFilter);
    filter.linePerPage = pagination.limit;
    filter.page = pagination.offset;
    if (pagination.sort !== '' && pagination.order.replace(/\s/g, '').length > 0) {
      filter.sortBy = pagination.sort;
      filter.direction = pagination.order;
    }
    return filter;
  }

  preparePrint(yes: string, no: string) {
    return [this.firstName, this.lastName, this.role.level > -1 ? (this.role.level === 0 ? '*' + '-' + this.role.name : this.role.level + '-' + this.role.name) : this.role.name, this.email ? this.email : '-', this.username ? this.username : '-', this.registered ? yes : no, this.country ? this.country : '-', this.group.length > 0 ? this.group.join(' ;') : '-', this.department ? this.department : '-', (this.countryCode && this.phone) ? '(' + this.countryCode + ') ' + this.phone : '-', this.desktopVersion ? this.desktopVersion : '-', this.mobileVersion ? this.mobileVersion : '-', (this.activated === 1 || this.activated === 0 || this.activated === undefined) ? '-' : this.activated, this.lastAppActivity ? this.lastAppActivity : '-'];
  }
  // check this
  preparePrintUsersOfGroup(group) {
    // tslint:disable-next-line: max-line-length
    return [this.email ? this.email : '-', this.username ? this.username : '-', this.firstName, this.lastName, (this.countryCode && this.phone) ? '(' + this.countryCode + ') ' + this.phone : '-', group];
  }

  updateProfile(input: any) {
    if (input.firstName) {
      this.firstName = input.firstName;
    }
    if (input.lastName) {
      this.lastName = input.lastName;
    }
    if (input.email) {
      this.email = input.email;
    }
    if (input.username) {
      this.username = input.username;
    }
    if (input.imageUrl) {
      this.imageUrl = input.imageUrl;
    }
    if (input.countryCode) {
      this.countryCode = input.countryCode;
    }
    if (input.phone) {
      this.phone = input.phone;
    }
  }

  getFullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  prepareFilterGroup() {
    const filter: any = {};
    if (this.firstName && this.firstName.replace(/\s/g, '').length > 0) {
      filter.firstName = this.firstName;
    }
    if (this.lastName && this.lastName.replace(/\s/g, '').length > 0) {
      filter.lastName = this.lastName;
    }
    if (this.email && this.email.replace(/\s/g, '').length > 0) {
      filter.email = this.email;
    }
    if (this.username && this.username.replace(/\s/g, '').length > 0) {
      filter.username = this.username;
    }
    if (this.role.name && this.role.name.replace(/\s/g, '').length > 0) {
      filter.role = this.role.name;
    }
    return filter;
  }

  isEmpty(): boolean {
    return !!(this.email?.length ||
      this.username?.length ||
      this.firstName?.length ||
      this.lastName?.length ||
      (this.phone?.toString().length) ||
      this.country?.length ||
      ((typeof this.activated === 'string' || typeof this.activated === 'number') && [1, 2, 3].includes(Number(this.activated))) ||
      [1, 2, 3, 4].includes(this.lastAppLoginStatus) ||
      [1, 2, 3, 4].includes(this.lastAppActivityStatus) ||
      (this.group && this.group.join().length) ||
      this.registered === true ||
      this.registered === false ||
      this.department?.length ||
      (this.role && this.role.name?.length)
    );
  }

  getInitialsLetter(): string {
    const firstName = this.firstName || '';
    const lastName = this.lastName || '';

    const firstInitial = firstName.charAt(0).toUpperCase();

    const lastNameParts = lastName.trim().split(' ');
    const lastWord = lastNameParts[lastNameParts.length - 1] || '';
    const lastInitial = lastWord.charAt(0).toUpperCase();

    return firstInitial + lastInitial;
  }

}

export interface UserGroup {
  id: number;
  firstName: string;
  lastName: string;
  role: Role;
  email?: string;
  username?: string;
  checked?: boolean;
  group: string[];
}
